if (!customElements.get('aotd-navigation')) {
  customElements.define('aotd-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.toggleButton = this.querySelector('.aotd-menu-toggle');
      this.groups = [...this.querySelectorAll('.aotd-nav__group')];
      this.setAttribute('data-enhanced', '');
      this.toggleButton.hidden = false;
      this.toggleButton.addEventListener('click', () => this.setMenu(!this.hasAttribute('data-menu-open')), options);
      this.groups.forEach(group => {
        group.addEventListener('toggle', () => {
          group.querySelector('summary').setAttribute('aria-expanded', String(group.open));
          if (group.open) this.groups.filter(other => other !== group).forEach(other => { other.open = false; });
        }, options);
        group.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' && matchMedia('(min-width: 901px) and (hover: hover)').matches) group.open = true;
        }, options);
        group.addEventListener('pointerleave', () => {
          if (matchMedia('(min-width: 901px) and (hover: hover)').matches && !group.contains(document.activeElement)) group.open = false;
        }, options);
        group.addEventListener('focusout', event => {
          if (matchMedia('(min-width: 901px)').matches && !group.contains(event.relatedTarget)) group.open = false;
        }, options);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const group = event.target.closest('.aotd-nav__group[open]');
        if (group) { group.open = false; group.querySelector('summary').focus(); }
        else if (this.hasAttribute('data-menu-open')) { this.setMenu(false); this.toggleButton.focus(); }
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) { this.setMenu(false); this.groups.forEach(group => { group.open = false; }); }
      }, options);
      this.media = matchMedia('(min-width: 901px)');
      this.media.addEventListener('change', () => { this.setMenu(false); this.groups.forEach(group => { group.open = false; }); }, options);
    }
    setMenu(open) {
      this.toggleAttribute('data-menu-open', open);
      this.toggleButton.setAttribute('aria-expanded', String(open));
      this.toggleButton.setAttribute('aria-label', open ? this.toggleButton.dataset.closeLabel : this.toggleButton.dataset.openLabel);
      if (!open) this.groups.forEach(group => { group.open = false; });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
